import { render, staticRenderFns } from "./b-textarea.vue?vue&type=template&id=12117640&"
import script from "./b-textarea.vue?vue&type=script&lang=js&"
export * from "./b-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports